import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './ErrorBoundary';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Login from './pages/login/login';
import { Provider } from 'react-redux';
import { store } from './store';
import USER from './pages/dddUI/user';
import ModakRules from './pages/modak/Rules';
import ModakHome from './pages/modak/Home';
import ModakRound1 from './pages/modak/Round1';
import ModakRound2 from './pages/modak/Round2';
import ModakRound3 from './pages/modak/Round3';
import ModakRound4 from './pages/modak/Round4';
import ModakRound5 from './pages/modak/Round5';
import ModakThankYou from './pages/modak/ThankYou';

function App() {
  return (
    <Provider store={store}>
      <USER>
        <Routes>
          <Route index element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/rules" element={<ModakRules />} />
          <Route path="/home" element={<ModakHome />} />
          <Route path="/bhog-a-licious" element={<ModakRound1 />} />
          <Route path="/music-o-logy" element={<ModakRound2 />} />
          <Route path="/name-a-thon" element={<ModakRound3 />} />
          <Route path="/symbols" element={<ModakRound4 />} />
          <Route path="/avatar" element={<ModakRound5 />} />
          <Route path="/thankyou" element={<ModakThankYou />} />
        </Routes>
      </USER>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ErrorBoundary>
);

reportWebVitals();
